import { createUseStyles } from 'react-jss';
import { palette } from '@shipium-corp/shipium-ui-theme';
import { headerBackground } from '../../layout/styles';

export const useConfigStyles = createUseStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    background: headerBackground,
    position: 'sticky',
    zIndex: 2,
    top: '0px',
    width: '100%',
    borderBottom: '1px solid #dddddd',
    justifyContent: 'space-between',
    padding: '15px',
    paddingLeft: '20px',
  },
  tabHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '64px',
    background: headerBackground,
    position: 'sticky',
    zIndex: 100,
    // Stick at the top of the scroll container — the global HeaderBar lives outside
    // `.content`, so there's no offset to account for here.
    top: 0,
    width: '100%',
    borderBottom: '1px solid #dddddd',
    paddingLeft: '30px',
  },
  content: {
    height: '100%',
    minHeight: 'calc(100vh - 64px - 70px - 56px - 40px)',
    margin: '20px',
    position: 'relative',
  },
  progressBarWrapper: {
    position: 'sticky',
    width: '100%',
    minHeight: '56px',
    bottom: '0px',
    flex: '1 1 auto',
    zIndex: 100,
  },
  progressBar: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    background: headerBackground,
    bottom: '0px',
    zIndex: 2,
    width: '100%',
    borderTop: '1px solid #dddddd',
    padding: '14px',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
  },
  progressButton: {
    width: '200px',
  },
  addButton: {
    backgroundColor: `${palette.Fuschia.normal} !important`,
    borderColor: `${palette.Fuschia.normal} !important`,
    transition: '0.3s',
    '&:hover': {
      backgroundColor: `${palette.Fuschia.light} !important`,
      borderColor: `${palette.Fuschia.light} !important`,
    },
    marginRight: '14px',
  },
  formCard: {
    marginBottom: '10px',
  },
  form: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  editCard: {
    position: 'absolute',
    right: '20px',
    top: '20px',
  },
  tableCellCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
});
